const colors = {
  // Primary - Metallic chrome/silver
  primary: {
    light: '#d1d5db',
    main: '#9ca3af',
    dark: '#6b7280',
    gradient: 'linear-gradient(135deg, #e5e7eb 0%, #9ca3af 50%, #6b7280 100%)',
  },

  // Accent - BMW Blue
  accent: {
    light: '#60a5fa',
    main: '#0066b1',
    dark: '#004785',
    gradient: 'linear-gradient(135deg, #3b82f6 0%, #0066b1 50%, #004785 100%)',
  },

  // Background - Dark metallic blacks and grays
  background: {
    darker: '#0a0a0a',
    dark: '#0f0f0f',
    medium: '#141414',
    light: '#1c1c1c',
    card: '#181818',
    white: '#ffffff',
    offWhite: '#0c0c0c',
  },

  // Metallic effects
  metallic: {
    silver: 'linear-gradient(145deg, #e8e8e8 0%, #b8b8b8 25%, #d4d4d4 50%, #a0a0a0 75%, #c0c0c0 100%)',
    chrome: 'linear-gradient(145deg, #f5f5f5 0%, #c9c9c9 20%, #e0e0e0 40%, #b0b0b0 60%, #d0d0d0 80%, #a8a8a8 100%)',
    steel: 'linear-gradient(145deg, #71717a 0%, #52525b 50%, #3f3f46 100%)',
    darkSteel: 'linear-gradient(145deg, #3f3f46 0%, #27272a 50%, #18181b 100%)',
  },

  // Text
  text: {
    white: '#ffffff',
    light: '#a1a1aa',
    muted: '#71717a',
    dark: '#e4e4e7',
    heading: '#fafafa',
    silver: '#d4d4d8',
  },

  // Status
  status: {
    success: '#22c55e',
    warning: '#f59e0b',
    danger: '#ef4444',
    info: '#3b82f6',
  },

  // Utility
  border: '#27272a',
  borderLight: '#3f3f46',
  borderMetallic: 'linear-gradient(145deg, #52525b, #27272a)',
  shadow: 'rgba(0, 0, 0, 0.5)',
  shadowLight: 'rgba(0, 0, 0, 0.3)',
  shadowMetallic: '0 4px 20px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.05)',
  overlay: 'rgba(0, 0, 0, 0.9)',
  glow: '0 0 40px rgba(0, 102, 177, 0.3)',
  glowAccent: '0 0 30px rgba(0, 102, 177, 0.4)',
};

export default colors;
